import React from 'react';

import type CK from '~/types/contentking';



type SelectedAccountContextValue = {
	selectedAccountId: CK.AccountId | null,
	setSelectedAccountId: (accountId: CK.AccountId | null) => void,
};

const SelectedAccountContext = React.createContext<SelectedAccountContextValue>({
	selectedAccountId: null,
	setSelectedAccountId: () => {
		// Default no-op
	},
});

export const SelectedAccountProvider: React.FC<{
	children: React.ReactNode,
}> = (props) => {
	const {
		children,
	} = props;

	const [
		selectedAccountId,
		setSelectedAccountId,
	] = React.useState<CK.AccountId | null>(null);

	const value = React.useMemo(
		() => ({
			selectedAccountId,
			setSelectedAccountId,
		}),
		[
			selectedAccountId,
		],
	);

	return (
		<SelectedAccountContext.Provider value={value}>
			{children}
		</SelectedAccountContext.Provider>
	);
};

export const useSelectedAccount = (): SelectedAccountContextValue => {
	return React.useContext(SelectedAccountContext);
};

export default SelectedAccountContext;
